import { MonitorBase } from './_MonitorBase';

export class MonitorVersions extends MonitorBase {
  constructor(game, parent, config) {
    super(game, parent, { label: 'versions', ...config });
    this.updateMonitor();
  }

  shutdown() {}

  updateMonitor() {
    let versionString = `Phaser: ${Phaser.VERSION}, Build: ${JW_VERSION}`;
    this.setValue(versionString);
  }

  getLog() {
    let str = '';
    str += `\nPhaser Version\t\t: ${Phaser.VERSION}`;
    str += `\nBuild Version\t\t: ${JW_VERSION}`;
    return str;
  }
}
